import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core'
import { QuoteTrackingService } from '../../quote-tracking.service'
import { Observable } from 'rxjs'
import { Router } from '@angular/router'
import { Actions, ofType } from '@ngrx/effects'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { DeliveryAddress } from '../../../quote-checkout/model/address-models'

import { LaunchDialogService } from '@spartacus/storefront'
import { filter, take } from 'rxjs/operators'

import { ActiveCartFacade, MultiCartFacade } from '@spartacus/cart/base/root'
import { CartActions } from '@spartacus/cart/base/core'
import {
  ACCESSIBILITY,
  UserRoleService,
} from '../../../../../shared/services/user-role.service'
import {
  CurrentQuoteStatus,
  QuoteStatus,
} from '../../../../../models/status/status.model'
import {
  DialogResponse,
  VS_LAUNCH_CALLER,
} from '../../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'vs-merge-quote-products-list',
  templateUrl: './merge-quote-products-list.component.html',
  styleUrls: ['./merge-quote-products-list.component.scss'],
})
export class MergeQuoteProductsListComponent implements OnInit, OnDestroy {
  quoteDetails$: Observable<any>
  allChecked = false
  checked = false
  quoteItems: any
  quoteDetailsData: any
  newCartId: any
  client: any = { indeterminated: false, checked: false }
  isMasterSel: boolean = false
  userType = 'current'
  count = 0
  rejectCount = 0
  loading: boolean
  filteredRecords: any
  @Output() getQuoteLineDetails = new EventEmitter<any>()
  accessibility = ACCESSIBILITY
  setWarningMsg: boolean = false
  isDelvGrpReq: boolean

  constructor(
    public quoteTrackingService: QuoteTrackingService,
    private router: Router,
    private actions$: Actions,
    private multiCartService: MultiCartFacade,
    private globalMessageService: GlobalMessageService,
    private launchDialogService: LaunchDialogService,
    protected cartService: ActiveCartFacade,
    private userRoleService: UserRoleService
  ) {}
  @Input() quote
  @Input() dateObject
  public showToggle = true
  @Input() acceptance
  @Input() quoteAcceptanceType
  @Input() addresses
  shipToAddress: DeliveryAddress
  billToAddress: DeliveryAddress
  endUserAddress: DeliveryAddress
  cart
  CurrentQuoteStatus = CurrentQuoteStatus
  lineItems = []
  rejectLineItems = []
  ngOnInit(): void {
    if (this.quote) {
      this.quoteDetails$ = this.quoteTrackingService.getQuoteDetailsFromList(
        this.quote?.quoteId,
        this.dateObject.fromDate,
        this.dateObject.toDate
      )
    } else {
      return
    }
    this.quoteDetails$.subscribe((success) => {
      this.quoteDetailsData = success
      this.filteredRecords = this.quoteDetailsData?.quoteLineDetails.filter(
        (item) => item.quoteStatus === ''
      )
      var ship = this.quoteDetailsData.quoteDetailsList.shipToAddress.split(';')
      this.shipToAddress = {
        partnerNumber: ship[0],
        companyName: ship[1],
        line1: ship[3],
        line2: ship[2],
        town: ship[4],
        city: ship[5],
        region: {
          isocode: ship[7] + '-' + ship[6],
        },
        country: {
          isocode: ship[7],
        },
        postalCode: ship[8],
      }
      var sold = this.quoteDetailsData.quoteDetailsList.soldToAddress.split(';')
      this.billToAddress = {
        companyName: sold[0],
        line1: sold[2],
        line2: sold[1],
        town: sold[3],
        city: sold[4],
        region: {
          isocode: sold[6] + '-' + sold[5],
        },
        country: {
          isocode: sold[6],
        },
        postalCode: sold[7],
      }
      var end =
        this.quoteDetailsData.quoteDetailsList.endUserAddresss.split(';')
      this.endUserAddress = {
        partnerNumber: end[0],
        companyName: end[1],
        line1: end[3],
        line2: end[2],
        town: end[4],
        city: end[5],
        region: {
          isocode: end[7] + '-' + end[6],
        },
        country: {
          isocode: end[7],
        },
        postalCode: end[8],
      }
      this.quoteItems = this.quoteDetailsData?.quoteLineDetails
      var obj = {
        quoteId: this.quote?.quoteId,
        quoteDetailsData: this.quoteDetailsData,
      }
      this.getQuoteLineDetails.emit(obj)
    })

    this.cartService.getActive().subscribe(
      (success) => {
        this.cart = success
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  toggleThis() {
    this.showToggle = !this.showToggle
  }
  setAll(cliente, event) {
    this.allChecked = event.target.checked
    this.isMasterSel = event.target.checked
    cliente.checked = event.target.checked
    cliente.indeterminated = false
    this.checked = event.target.checked
    this.changeCheck()
  }

  setDeliveryGroup(event) {
    this.isDelvGrpReq = !this.isDelvGrpReq
    console.log(this.isDelvGrpReq, ' ---- ', event.target.checked)
  }

  getStatusByCount() {
    if (
      this.count === this.lineItems.length &&
      this.lineItems.length === this.quoteDetailsData?.quoteLineDetails.length
    ) {
      if (this.quoteAcceptanceType == 'additional') {
        return QuoteStatus.ADDITIONALFULL
      }
      return QuoteStatus.FULL
    } else {
      if (this.quoteAcceptanceType == 'additional') {
        return QuoteStatus.ADDITIONALPARTIAL
      }
      return QuoteStatus.PARTIAL
    }
  }
  getRejectStatusByCount() {
    if (
      this.rejectLineItems.length ==
      this.quoteDetailsData?.quoteLineDetails.length
    ) {
      return QuoteStatus.REJECT
    } else {
      return QuoteStatus.PARTIALREJECT
    }
  }
  changeCheck() {
    this.allChecked = this.checked
    var i = 1
    if (this.allChecked === true) {
      for (let quoteLineItem of this.quoteItems) {
        if (quoteLineItem.quantity == 0) {
          this.setWarningMsg = true
        }
        if (
          quoteLineItem.quoteStatusCode === CurrentQuoteStatus.OPEN &&
          quoteLineItem.quoteStatus === '' &&
          quoteLineItem.quantity > 0 &&
          quoteLineItem.isOrderCreated == false
        ) {
          let obj = {
            itemNum: i++,
            rfqPartNumber: quoteLineItem?.partNumber,
            entryType: quoteLineItem?.entryType,
            customerMaterialNumber: quoteLineItem?.customerMaterialNumber,
            quoteRejectReason: '',
            quoteRejectReasonDesc: '',
          }
          this.rejectLineItems.push(obj)

          let lineItem = {
            brandCode: '',
            brandName: '',
            code: '',
            comment: '',
            csrResponseRequired: true,
            customerRequestedDate: '',
            assignedShipDate: '',
            discountValues: [],
            priceAdderData: [],
            isUnsolicited: true,
            productType: '',
            quantity: 0,
            listPrice: 0,
            quoteCartEntryType: '',
            quoteExtendedPrice: 0,
            quoteNetPrice: 0,
            reasonForQuote: '',
            rfqPartDescription: '',
            rfqPartNumber: '',
            serialNumber: '',
            tagNumber: '',
            itemNumber: '',
            entryType: '',
            customerMaterialNumber: '',
          }
          lineItem = {
            csrResponseRequired: true,
            brandCode: 'MASONEILAN',
            brandName: 'MASONEILAN',
            comment: quoteLineItem?.additionalComments,
            customerRequestedDate: quoteLineItem?.requestedShipDate.replace(/-/g, '/'),
            assignedShipDate: quoteLineItem?.newDeliveryDate.replace(/-/g, '/'),
            code: quoteLineItem?.partNumber,
            discountValues: quoteLineItem?.discountValues,
            priceAdderData: quoteLineItem?.priceAdderData,
            isUnsolicited: true,
            productType: 'Part',
            quantity: Number(quoteLineItem?.quantity),
            reasonForQuote: '',
            quoteExtendedPrice: Number(quoteLineItem?.quoteExtendedPrice),
            quoteNetPrice: Number(quoteLineItem?.quoteNetPrice),
            listPrice: Number(quoteLineItem?.listPrice),
            rfqPartDescription: quoteLineItem?.partDescription,
            serialNumber: quoteLineItem?.serialNumber,
            rfqPartNumber: quoteLineItem?.partNumber,
            tagNumber: quoteLineItem?.tagNumber,
            quoteCartEntryType: this.getStatusByCount(),
            itemNumber: quoteLineItem?.itemNumber,
            entryType: quoteLineItem?.entryType,
            customerMaterialNumber: quoteLineItem?.customerMaterialNumber,
          }
          this.lineItems.push(lineItem)
        }
      }
    } else {
      this.lineItems = []
      this.rejectLineItems = []
    }
  }
  openAcceptModal(deliveryFlag) {
    this.isDelvGrpReq = deliveryFlag

    if (this.lineItems.length < 1) {
      this.globalMessageService.add(
        { key: 'quoteTracking.selectOneProduct' },
        GlobalMessageType.MSG_TYPE_WARNING,
        5000
      )
      return
    }
    if (this.cart?.entries?.length > 0 || this.setWarningMsg == true) {
      const componentdata = {
        warningMsg: this.setWarningMsg,
      }

      const acceptQuoteDialog = this.launchDialogService.openDialog(
        VS_LAUNCH_CALLER.ACCEPT_QUOTE,
        undefined,
        undefined,
        componentdata
      )
      if (acceptQuoteDialog) {
        acceptQuoteDialog.pipe(take(1)).subscribe((value) => {})
        this.launchDialogService.dialogClose
          .pipe(
            filter(
              (dialogResponse: DialogResponse) =>
                dialogResponse?.type == VS_LAUNCH_CALLER.ACCEPT_QUOTE
            ),
            take(1)
          )
          .subscribe((value) => {
            if (value?.reason == 'accept-quote') {
              // do something
              this.acceptSelected()
            } else {
            }
          })
      }
    } else {
      this.acceptSelected()
    }
  }
  acceptSelected() {
    this.loading = true
    let itemNumberArr = []
    this.quoteDetailsData?.quoteLineDetails.forEach((element) => {
      if (
        element.quoteStatusCode === CurrentQuoteStatus.OPEN &&
        element.quantity > 0 &&
        element.isOrderCreated == false
      ) {
        this.count++
      }
    })
    var ship = this.quoteDetailsData.quoteDetailsList.shipToAddress.split(';')
    this.shipToAddress = {
      partnerNumber: ship[0],
      companyName: ship[1],
      line1: ship[3],
      line2: ship[2],
      town: ship[4],
      region: {
        isocode: ship[7] + '-' + ship[6],
      },
      country: {
        isocode: ship[7],
      },
      postalCode: ship[8],
    }
    var sold = this.quoteDetailsData.quoteDetailsList.soldToAddress.split(';')
    this.billToAddress = {
      companyName: sold[0],
      line1: sold[2],
      line2: sold[1],
      town: sold[3],
      region: {
        isocode: sold[6] + '-' + sold[5],
      },
      country: {
        isocode: sold[6],
      },
      postalCode: sold[7],
    }
    var end = this.quoteDetailsData.quoteDetailsList.endUserAddresss.split(';')
    this.endUserAddress = {
      partnerNumber: end[0],
      companyName: end[1],
      line1: end[3],
      line2: end[2],
      town: end[4],
      region: {
        isocode: end[7] + '-' + end[6],
      },
      country: {
        isocode: end[7],
      },
      postalCode: end[8],
    }
    this.lineItems.forEach((element) => {
      element['quoteCartEntryType'] = this.getStatusByCount()
      itemNumberArr.push(element.itemNumber + '|' + this.quote?.quoteId)
    })
    this.lineItems.forEach((element) => {
      element['quoteCartEntryType'] = this.getStatusByCount()
    })
    var quoteObject = {
      billToAddress: this.billToAddress,
      deliveryAddress: this.shipToAddress,
      endUserAddress: this.endUserAddress,
      quoteCartType: this.getStatusByCount(),
      quoteEntries: this.lineItems,
      quoteId: this.quote?.quoteId,
      contactNumber: null,
      customerProjectName:
        this.quoteDetailsData?.quoteDetailsList?.customerProjectName,
      endUserIndustry: this.quoteDetailsData?.quoteDetailsList?.endUserIndustry,
      notificationEmail:
        this.quoteDetailsData?.quoteDetailsList?.notificationEmail,
      customerReviewCheck: null,
      hasRestrictedUse: null,
      isNuclear: null,
      legalEntity: null,
      requiresExportLicense: null,
      restrictedCountryCheck: null,
      rfqType: this.quoteDetailsData?.quoteDetailsList?.rfqType,
      sanctionCheck: null,
    }
    this.quoteTrackingService.acceptQuote(quoteObject).subscribe(
      (success) => {
        this.loading = false
        sessionStorage.setItem('itemNumber', itemNumberArr.toString())
        this.newCartId = success['code']
        this.multiCartService.loadCart({
          userId: this.userType,
          cartId: this.newCartId,
          extraData: {
            active: true,
          },
        })
        this.actions$
          .pipe(ofType(CartActions.LOAD_CART_SUCCESS), take(1))
          .subscribe((success) => {
            if (this.quoteAcceptanceType == 'additional') {
              this.router.navigate(['cart'])
            } else {
              if (this.isDelvGrpReq) {
                this.router.navigate(['cart'])
              } else {
                this.router.navigate(['cart/checkout'])
              }
            }
          })
      },
      (error) => {
        this.loading = false
      }
    )
  }
  openRejectPopUp() {
    if (this.lineItems.length < 1) {
      this.globalMessageService.add(
        { key: 'quoteTracking.selectOneProduct' },
        GlobalMessageType.MSG_TYPE_WARNING,
        5000
      )
      return
    }
    const componentdata = {
      quoteId: this.quote?.quoteId,
    }

    const rejectQuoteDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.REJECT_QUOTE,
      undefined,
      undefined,
      componentdata
    )
    if (rejectQuoteDialog) {
      rejectQuoteDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.REJECT_QUOTE
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value?.data?.reasonForRejection || value?.data?.comments) {
            this.rejectSelected(value)
          }
        })
    }
  }
  rejectSelected(value) {
    //this.quoteTrackingService.emitRejectOnce(true);

    for (var i = 0; i < this.rejectLineItems.length; i++) {
      this.rejectLineItems[i].quoteRejectReason = value?.reasonForRejection
      this.rejectLineItems[i].quoteRejectReasonDesc = value?.comments
    }
    var obj = {
      quoteCartType: this.getRejectStatusByCount(),
      quoteId: this.quote?.quoteId,
      quoteEntries: this.rejectLineItems,
    }
    this.quoteTrackingService.rejectQuote(obj).subscribe((success) => {
      this.globalMessageService.add(
        { key: 'quoteTracking.quoteRejected' },
        GlobalMessageType.MSG_TYPE_CONFIRMATION,
        3000
      )
      setTimeout(() => {
        this.router.navigate(['quote-detail', this.quote?.quoteId], {
          queryParams: this.dateObject,
        })
      }, 3000)
    })
  }

  ngOnDestroy() {
    // this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_WARNING);
  }
  productCheck(event) {
    sessionStorage.setItem("selectedQuoteId", this.quote.quoteId)
    this.getQuoteLineDetails.emit(event)
    if (event.checked === true) {
      this.addCheckedToArray(event.code, event.index)
    } else {
      this.removeUncheckedFromArray(event.code, event.index, event.itemNumber);
    }
  }
  addCheckedToArray(code, index) {
    let rejectLineItem = {
      itemNum: index + 1,
      rfqPartNumber: this.quoteItems[index]?.partNumber,
      entryType: this.quoteItems[index]?.entryType,
      customerMaterialNumber: this.quoteItems[index]?.customerMaterialNumber,
      quoteRejectReason: '',
    }

    this.rejectLineItems.push(rejectLineItem)

    let lineItem = {
      brandCode: '',
      brandName: '',
      code: '',
      comment: '',
      csrResponseRequired: true,
      customerRequestedDate: '',
      assignedShipDate: '',
      isUnsolicited: true,
      productType: '',
      quantity: 0,
      discountValues: [],
      priceAdderData: [],
      listPrice: 0,
      quoteCartEntryType: '',
      quoteExtendedPrice: 0,
      quoteNetPrice: 0,
      reasonForQuote: '',
      rfqPartDescription: '',
      rfqPartNumber: '',
      serialNumber: '',
      tagNumber: '',
      itemNumber: '',
      netP: '',
      zumuPrice: '',
      entryType: '',
      customerMaterialNumber: '',
    }
    lineItem = {
      csrResponseRequired: true,
      brandCode: 'MASONEILAN',
      brandName: 'MASONEILAN',
      comment: this.quoteItems[index]?.additionalComments,
      customerRequestedDate: this.quoteItems[index]?.requestedShipDate.replace(/-/g, '/'),
      assignedShipDate: this.quoteItems[index]?.newDeliveryDate.replace(/-/g, '/'),
      code: this.quoteItems[index]?.partNumber,
      isUnsolicited: true,
      productType: 'Part',
      discountValues: this.quoteItems[index]?.discountValues,
      priceAdderData: this.quoteItems[index]?.priceAdderData,
      quantity: Number(this.quoteItems[index]?.quantity),
      reasonForQuote: '',
      quoteExtendedPrice: Number(this.quoteItems[index]?.quoteExtendedPrice),
      quoteNetPrice: Number(this.quoteItems[index]?.quoteNetPrice),
      listPrice: Number(this.quoteItems[index]?.listPrice),
      rfqPartDescription: this.quoteItems[index]?.partDescription,
      serialNumber: this.quoteItems[index]?.serialNumber,
      rfqPartNumber: this.quoteItems[index]?.partNumber,
      tagNumber: this.quoteItems[index]?.tagNumber,
      quoteCartEntryType: this.getStatusByCount(),
      itemNumber: this.quoteItems[index]?.itemNumber,
      netP: this.quoteItems[index]?.netP,
      zumuPrice: this.quoteItems[index]?.zumuPrice,
      entryType: this.quoteItems[index]?.entryType,
      customerMaterialNumber: this.quoteItems[index]?.customerMaterialNumber,
    }
    this.lineItems.push(lineItem)

    if (
      this.filteredRecords.length > this.rejectLineItems.length &&
      this.filteredRecords.length !== 1
    ) {
      this.client.indeterminated = true
      this.client.checked = false
    } else {
      this.client.indeterminated = false
      this.client.checked = true
    }
  }
  removeUncheckedFromArray(code, index, itemNumber) {
    let i = 0,
      j = 0

    this.lineItems.forEach((element) => {
      if (code === element?.code && element?.itemNumber === itemNumber) {
        this.lineItems.splice(i, 1)
        return
      }
      i++
    })

    this.rejectLineItems.forEach((element) => {
      if (index === element.itemNum - 1) {
        this.rejectLineItems.splice(j, 1)
        return
      }
      i++
    })
      

    if (
      this.filteredRecords.length > this.rejectLineItems.length &&
      this.filteredRecords.length !== 1
    ) {
      this.client.indeterminated = true
      this.client.checked = false
    } else {
      this.client.indeterminated = false
      this.client.checked = false
    }
  }

  checkUserEnabled(flagName) {
    return this.userRoleService.checkUserRoleEnabled(flagName)
  }
}
